import axios from 'axios';

// 加载 Wi-Fi 数据的函数
export const fetchWifiData = async () => {
  try {
    const { hostname } = window.location;
    const localIPAddress = hostname.split(':')[0];

    // 添加配置选项来处理跨域请求
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      // 允许跨域请求
      withCredentials: false,
      timeout: 5000, // 5秒超时
    };

    // 使用 HTTPS 链接
    const response = await axios.get('https://wifiapi.est-live.cn/api/wifi-data', config);

    const data = response.data;
    console.log('成功获取数据:', data);
    // TODO: 根据需要对数据进行处理，确保返回的数据结构符合您的预期
    // 例如，解析数据、过滤数据等操作

    return data; // 返回处理后的数据
  } catch (error) {
    // 更详细的错误日志
    console.error('获取 Wi-Fi 数据时出错:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
    });

    throw error; // 向上抛出错误，让调用者处理
  }
};